var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:`button button_${_vm.color}`,attrs:{"href":_vm.link,"data-qa":"apply-tariff-upgrade"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$trlMessage('promo.upgrade.apply')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }